/**
 * PDP Hidrogel — comportamento portado de pace-it-pdp.html
 * (seleção de faixa, mix de sabores, checkout, galeria, add to cart, barra mobile)
 */
class PdpHidrogel {
  constructor(container) {
    this.container = container;
    const dataEl = container.querySelector("[data-pdp-hidrogel-json]");
    this.data = JSON.parse(dataEl.textContent);
    this.basePriceCents = this.data.basePriceCents;
    this.pixDiscountPct = this.data.pixDiscountPct;
    this.tiers = this.data.tiers;
    this.flavors = this.data.flavors;
    this.subscriptionThreshold = this.data.subscriptionThreshold || 20;
    this.assinaturaUnitPriceCents = this.data.assinaturaUnitPriceCents || 0;
    this.addons = this.data.addons || [];
    this.assinaturaOffPct = this.assinaturaUnitPriceCents
      ? Math.round((1 - this.assinaturaUnitPriceCents / this.basePriceCents) * 100)
      : 0;
    this.purchaseMode = "unica";
    this.addonsSelected = {};
    this.addonMode = {};

    this.tiersEl = container.querySelector("[data-tiers]");
    this.qtyBoxEl = container.querySelector("[data-qtybox]");
    this.qtyBoxLabelEl = container.querySelector("[data-qtybox-label]");
    this.qtyOutEl = container.querySelector("[data-qty-out]");
    this.qtyMinusEl = container.querySelector("[data-qty-minus]");
    this.qtyPlusEl = container.querySelector("[data-qty-plus]");
    this.flavorsEl = container.querySelector("[data-flavors]");
    this.mixCountEl = container.querySelector("[data-mix-count]");
    this.autoMixEl = container.querySelector("[data-auto-mix]");
    this.flavorCardsEl = container.querySelector("[data-flavor-cards]");
    this.totalFromEl = container.querySelector("[data-total-from]");
    this.totalPriceEl = container.querySelector("[data-total-price]");
    this.unitLineEl = container.querySelector("[data-unit-line]");
    this.perkLineEl = container.querySelector("[data-perk-line]");
    this.pmodesEl = container.querySelector("[data-pmodes]");
    this.pmodeBenefitsEl = container.querySelector("[data-pmode-benefits]");
    this.pmodeBenefitsLockEl = container.querySelector("[data-pmode-benefits-lock]");
    this.pmodeBenefitsLockTextEl = container.querySelector("[data-pmode-benefits-lock-text]");
    this.assinaturaOffEl = container.querySelector("[data-assinatura-off]");
    this.assinaturaBenefitOffEl = container.querySelector("[data-assinatura-benefit-off]");
    this.addonCheckEls = Array.from(container.querySelectorAll("[data-addon-check]"));
    this.addonOfferCheckEl = container.querySelector("[data-addon-offer-check]");
    this.addonLineEl = container.querySelector("[data-addon-line]");
    this.ctaBtnEl = container.querySelector("[data-cta-btn]");
    this.ctaLabelEl = this.ctaBtnEl ? this.ctaBtnEl.querySelector("[data-cta-label]") : null;
    this.ctaFillEl = this.ctaBtnEl ? this.ctaBtnEl.querySelector("[data-cta-fill]") : null;
    this.nutritionOpenEl = container.querySelector("[data-nutrition-open]");
    this.nutritionModalEl = container.querySelector("[data-nutrition-modal]");
    this.nutritionTabsEl = container.querySelector("[data-nutrition-tabs]");
    this.nutritionImageEl = container.querySelector("[data-nutrition-image]");
    this.nutritionEmptyEl = container.querySelector("[data-nutrition-empty]");
    this.mainImgEl = container.querySelector("[data-main-img]");
    this.thumbsEl = container.querySelector("[data-thumbs]");
    this.mobilebarEl = container.querySelector("[data-mobilebar]");
    this.mobileTotalEl = container.querySelector("[data-mobile-total]");
    this.mobileUnitEl = container.querySelector("[data-mobile-unit]");
    this.mobileFromEl = container.querySelector("[data-mobile-from]");
    this.mobileQtyEl = container.querySelector("[data-mobile-qty]");
    this.mobileModeEl = container.querySelector("[data-mobile-mode]");
    this.mobileCtaEl = this.mobilebarEl ? this.mobilebarEl.querySelector("[data-mobile-cta]") : null;
    this.mobileCtaLabelEl = this.mobilebarEl ? this.mobilebarEl.querySelector("[data-mobile-cta-label]") : null;
    this.mobileCtaFillEl = this.mobilebarEl ? this.mobilebarEl.querySelector("[data-mobile-cta-fill]") : null;

    this.tier = this.tiers[1] || this.tiers[0];
    this.qty = this.tier.quantity;
    this.mix = {};
    this.flavors.forEach((f) => {
      this.mix[f.variantId] = 0;
    });

    this.init();
  }

  formatPrice(cents) {
    return "R$ " + (cents / 100).toFixed(2).replace(".", ",");
  }

  sum() {
    return Object.values(this.mix).reduce((a, b) => a + b, 0);
  }

  pushEvent(name, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...data });
  }

  init() {
    this.renderTiers();
    this.renderFlavors();
    this.renderFlavorCards();
    this.bindGallery();
    this.bindFlavorZoom();
    this.bindNutritionModal();
    this.bindQtyBox();
    this.bindCta();
    this.bindStickyBar();
    this.bindPurchaseModes();
    this.bindAddon();
    this.bindAddonOffer();
    this.renderQtyBox();
    if (this.assinaturaOffEl) {
      this.assinaturaOffEl.textContent = this.assinaturaOffPct > 0 ? `-${this.assinaturaOffPct}% OFF` : "";
    }
    if (this.assinaturaBenefitOffEl) {
      this.assinaturaBenefitOffEl.textContent = this.assinaturaOffPct;
    }
    this.container.querySelectorAll("[data-addon-price]").forEach((el) => {
      const addon = this.addons[parseInt(el.dataset.addonPrice, 10)];
      if (addon) el.textContent = this.formatPrice(addon.priceCents);
    });
    this.container.querySelectorAll("[data-addon-offer-price]").forEach((el) => {
      const [idxStr, mode] = el.dataset.addonOfferPrice.split("-");
      const addon = this.addons[parseInt(idxStr, 10)];
      if (!addon) return;
      const cents = mode === "assinatura" && addon.assinaturaPriceCents ? addon.assinaturaPriceCents : addon.priceCents;
      el.textContent = this.formatPrice(cents);
    });
    this.update();
  }

  renderPurchaseModes() {
    if (!this.pmodesEl) return;
    const locked = this.qty < this.subscriptionThreshold || !this.assinaturaUnitPriceCents;
    const assinaturaBtn = this.pmodesEl.querySelector('[data-mode="assinatura"]');
    if (assinaturaBtn) assinaturaBtn.disabled = locked;
    if (locked && this.purchaseMode === "assinatura") this.purchaseMode = "unica";

    this.pmodesEl.querySelectorAll(".pmode").forEach((b) => {
      b.setAttribute("aria-pressed", b.dataset.mode === this.purchaseMode);
    });

    if (this.pmodeBenefitsEl) {
      this.pmodeBenefitsEl.classList.toggle("is-locked", locked);
    }

    if (this.pmodeBenefitsLockEl) {
      this.pmodeBenefitsLockEl.hidden = !locked;
      if (locked && this.pmodeBenefitsLockTextEl && this.assinaturaUnitPriceCents) {
        const missing = Math.max(0, this.subscriptionThreshold - this.qty);
        this.pmodeBenefitsLockTextEl.textContent =
          missing > 0
            ? `Faltam ${missing} ${missing === 1 ? "Hidrogel" : "Hidrogéis"} para desbloquear o modo assinatura`
            : "Assinatura indisponível para este produto.";
      }
    }

    this.syncAddonPlacement();
  }

  /**
   * When the add-on (index 0) has a subscription variant configured, it can be added either as a
   * one-time purchase (shown next to the other add-ons, "compra única") or as a subscribe-along
   * option (shown inside the "Benefícios da assinatura" card, "assinatura"). Only one of the two
   * controls is shown at a time, kept in sync with `purchaseMode`.
   */
  syncAddonPlacement() {
    if (!this.addonOfferCheckEl) return;

    const isAssinatura = this.purchaseMode === "assinatura";
    const checkboxEl = this.addonCheckEls.find((el) => parseInt(el.dataset.addonIndex, 10) === 0);
    const standaloneRow = this.container.querySelector('[data-addon-standalone-index="0"]');
    const offerWrap = this.addonOfferCheckEl.closest(".pmode__addon-offer");

    if (isAssinatura) {
      if (checkboxEl && checkboxEl.checked && this.addonMode[0] == null) {
        this.addonMode[0] = "avulso";
        this.addonsSelected[0] = true;
      }
    } else {
      if (this.addonMode[0] === "assinatura") this.addonMode[0] = "avulso";
      if (checkboxEl) checkboxEl.checked = !!this.addonsSelected[0];
    }

    if (standaloneRow) standaloneRow.hidden = isAssinatura;
    if (offerWrap) offerWrap.hidden = !isAssinatura;

    this.addonOfferCheckEl.checked = !!this.addonsSelected[0] && this.addonMode[0] === "assinatura";
  }

  bindPurchaseModes() {
    if (!this.pmodesEl) return;
    this.pmodesEl.addEventListener("click", (e) => {
      const b = e.target.closest(".pmode");
      if (!b || b.disabled) return;
      this.purchaseMode = b.dataset.mode;
      this.pushEvent("pdp_purchase_mode_selected", { purchase_mode: this.purchaseMode });
      this.update();
    });
  }

  bindAddon() {
    this.addonCheckEls.forEach((el) => {
      const index = parseInt(el.dataset.addonIndex, 10);
      el.addEventListener("change", () => {
        this.addonsSelected[index] = el.checked;
        const addon = this.addons[index];
        if (addon) {
          this.pushEvent("pdp_addon_selected", { addon_name: addon.name, selected: el.checked });
        }
        this.update();
      });
    });
  }

  bindAddonOffer() {
    if (!this.addonOfferCheckEl) return;
    this.addonOfferCheckEl.addEventListener("change", () => {
      const index = parseInt(this.addonOfferCheckEl.dataset.addonOfferIndex, 10);
      const checked = this.addonOfferCheckEl.checked;
      this.addonMode[index] = checked ? "assinatura" : null;
      this.addonsSelected[index] = checked;
      const addon = this.addons[index];
      if (addon) {
        this.pushEvent("pdp_addon_selected", { addon_name: addon.name, selected: checked, mode: "assinatura" });
      }
      this.update();
    });
  }

  renderTiers() {
    this.tiersEl.innerHTML = "";
    this.tiers.forEach((t) => {
      const off = Math.round((1 - t.unitPriceCents / this.basePriceCents) * 100);
      const desc =
        t.quantity === 1
          ? "Experimente um sabor"
          : t.quantity === 6
          ? "Para 1 a 2 treinos longos"
          : t.quantity === 12
          ? "Para 2 a 3 treinos longos"
          : t.open
          ? "Para quem treina com frequência"
          : "Para manter sua rotina de treinos";
      const li = document.createElement("li");
      li.innerHTML = `
        <button type="button" class="tier" role="radio" aria-pressed="${t === this.tier}" data-q="${t.quantity}">
          <span class="tier__radio" aria-hidden="true"></span>
          <span class="tier__main">
            <span class="tier__name">
              ${t.quantity}${t.open ? "+" : ""} ${t.quantity === 1 ? "sachê" : "sachês"}
              ${off > 0 ? `<span class="tier__off">-${off}% OFF</span>` : ""}
              ${t.tag ? `<span class="tier__tag">${t.tag}</span>` : ""}
            </span>
            <span class="tier__desc">${desc}</span>
          </span>
          <span class="tier__price">
            <span class="tier__price-main"><b>${this.formatPrice(t.unitPriceCents)}</b> <span class="tier__price-unit">/ sachê</span></span>
            <small>${t.open ? "a partir de " : ""}${this.formatPrice(t.unitPriceCents * t.quantity)}</small>
          </span>
        </button>`;
      this.tiersEl.appendChild(li);
    });

    this.tiersEl.addEventListener("click", (e) => {
      const b = e.target.closest(".tier");
      if (!b) return;
      this.tier = this.tiers.find((t) => t.quantity === +b.dataset.q);
      this.qty = this.tier.quantity;
      this.tiersEl.querySelectorAll(".tier").forEach((x) => x.setAttribute("aria-pressed", x === b));
      this.pushEvent("pdp_tier_selected", { tier_quantity: this.tier.quantity, tier_unit_price_cents: this.tier.unitPriceCents });
      this.renderQtyBox();

      let total = this.sum();
      while (total > this.qty) {
        const k = Object.keys(this.mix).reduce((a, b2) => (this.mix[a] >= this.mix[b2] ? a : b2));
        this.mix[k]--;
        total--;
      }
      this.update();
    });
  }

  renderQtyBox() {
    this.qtyBoxEl.hidden = !this.tier.open;
    if (this.tier.open) {
      this.qtyBoxLabelEl.innerHTML = `Quantos sachês? <small>mínimo ${this.tier.quantity} · ${this.formatPrice(this.tier.unitPriceCents)} cada</small>`;
    }
    this.qtyOutEl.value = this.qty;
    this.qtyMinusEl.disabled = this.qty <= this.tier.quantity;
  }

  bindQtyBox() {
    this.qtyPlusEl.addEventListener("click", () => {
      this.qty++;
      this.renderQtyBox();
      this.update();
    });
    this.qtyMinusEl.addEventListener("click", () => {
      if (this.qty > this.tier.quantity) {
        this.qty--;
        let t = this.sum();
        while (t > this.qty) {
          const k = Object.keys(this.mix).reduce((a, b) => (this.mix[a] >= this.mix[b] ? a : b));
          this.mix[k]--;
          t--;
        }
        this.renderQtyBox();
        this.update();
      }
    });
    this.qtyOutEl.addEventListener("change", () => {
      let val = parseInt(this.qtyOutEl.value, 10);
      if (isNaN(val) || val < this.tier.quantity) val = this.tier.quantity;
      this.qty = val;
      let t = this.sum();
      while (t > this.qty) {
        const k = Object.keys(this.mix).reduce((a, b) => (this.mix[a] >= this.mix[b] ? a : b));
        this.mix[k]--;
        t--;
      }
      this.renderQtyBox();
      this.update();
    });
  }

  renderFlavors() {
    this.flavorsEl.innerHTML = "";
    this.flavors.forEach((f) => {
      const li = document.createElement("li");
      li.className = "flavor";
      li.dataset.id = f.variantId;
      // ícone de grão de café no canto da miniatura substitui o texto "- Cafeína" no
      // nome — economiza espaço na linha e evita o nome ser cortado no mobile.
      const caffeineBadge = f.caffeine
        ? `<span class="flavor__caf-badge" title="Contém cafeína" aria-hidden="true"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#fff" stroke-width="2.1" stroke-linecap="round"><ellipse cx="12" cy="12" rx="6" ry="9.2"/><path d="M13.3 3.5C9 8 17 16 12.7 20.5"/></svg></span>`
        : "";
      const thumb = f.image
        ? `<span class="flavor__imgwrap"><img class="flavor__img" src="${f.image}" alt="Sachê Hidrogel Pace It sabor ${f.name}" loading="lazy" width="44" height="44"></span>`
        : `<span class="flavor__swatch" style="--sw:${f.swatch}"></span>`;
      li.innerHTML = `
        <span class="flavor__thumb">${thumb}${caffeineBadge}</span>
        <span>
          <span class="flavor__title">
            <span class="flavor__name">${f.name}</span>
            <button type="button" class="flavor__zoom" aria-label="Ver detalhes do sabor ${f.name}" aria-expanded="false">
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
              <span class="flavor__popover" role="tooltip">
                ${
                  f.image
                    ? `<span class="flavor__popover-img"><img src="${f.image}" alt="" loading="lazy"></span>`
                    : `<span class="flavor__popover-img flavor__swatch" style="--sw:${f.swatch}"></span>`
                }
                <span class="flavor__popover-body">
                  <b>${f.name}</b>
                  <span class="flavor__popover-stats">${f.sodium} mg sódio${f.caffeine ? ` · ${f.caffeine} mg cafeína` : ""}</span>
                  ${f.description ? `<p>${f.description}</p>` : ""}
                </span>
              </span>
            </button>
          </span>
          <span class="flavor__info">${f.sodium} mg sódio${f.caffeine ? ` · <span class="caf">${f.caffeine} mg caf</span>` : ""}</span></span>
        <span class="counter">
          <button type="button" data-d="-1" aria-label="Menos ${f.name}">−</button>
          <input type="number" inputmode="numeric" aria-live="polite" aria-label="Quantidade de ${f.name}" value="0">
          <button type="button" data-d="1" aria-label="Mais ${f.name}">+</button>
        </span>`;
      this.flavorsEl.appendChild(li);
    });

    this.flavorsEl.addEventListener("click", (e) => {
      const b = e.target.closest("button[data-d]");
      if (!b) return;
      const id = b.closest(".flavor").dataset.id;
      const d = +b.dataset.d;
      if (d > 0 && this.sum() >= this.qty) return;
      this.mix[id] = Math.max(0, (this.mix[id] || 0) + d);
      const flavor = this.flavors.find((f) => String(f.variantId) === String(id));
      if (flavor) {
        this.pushEvent("pdp_flavor_selected", {
          action: d > 0 ? "add" : "remove",
          flavor_name: flavor.name,
          flavor_quantity: this.mix[id],
        });
      }
      this.update();
    });

    this.flavorsEl.addEventListener("change", (e) => {
      const input = e.target.closest("input[type='number']");
      if (!input) return;
      const id = input.closest(".flavor").dataset.id;
      let val = parseInt(input.value, 10);
      if (isNaN(val) || val < 0) val = 0;
      const otherTotal = this.sum() - (this.mix[id] || 0);
      val = Math.min(val, Math.max(0, this.qty - otherTotal));
      this.mix[id] = val;
      const flavor = this.flavors.find((f) => String(f.variantId) === String(id));
      if (flavor) {
        this.pushEvent("pdp_flavor_selected", { action: "set", flavor_name: flavor.name, flavor_quantity: val });
      }
      this.update();
    });

    this.autoMixEl.addEventListener("click", () => {
      Object.keys(this.mix).forEach((k) => (this.mix[k] = 0));
      const order = this.flavors.map((f) => f.variantId);
      let left = this.qty;
      let i = 0;
      while (left > 0) {
        this.mix[order[i % order.length]]++;
        left--;
        i++;
      }
      this.update();
    });
  }

  renderFlavorCards() {
    if (!this.flavorCardsEl) return;
    this.flavorCardsEl.innerHTML = "";
    this.flavors.forEach((f) => {
      const a = document.createElement("article");
      a.className = "fcard";
      a.innerHTML = `
        <div class="fcard__img">${f.image ? `<img src="${f.image}" alt="Sachê Hidrogel Pace It sabor ${f.name}" loading="lazy">` : ""}</div>
        <div class="fcard__body">
          <h3>${f.name}</h3>
          <div class="fcard__stats"><span><b>${f.sodium}</b>mg sódio</span><span><b>${f.caffeine}</b>mg cafeína</span></div>
          <p>${f.description || ""}</p>
          <button type="button" class="fcard__add" data-id="${f.variantId}">Adicionar ao mix</button>
        </div>`;
      this.flavorCardsEl.appendChild(a);
    });

    this.flavorCardsEl.addEventListener("click", (e) => {
      const b = e.target.closest(".fcard__add");
      if (!b) return;
      const anchor = this.container.querySelector("#comprar");
      if (this.sum() >= this.qty) {
        if (anchor) anchor.scrollIntoView({ behavior: "smooth" });
        return;
      }
      this.mix[b.dataset.id]++;
      const flavor = this.flavors.find((f) => String(f.variantId) === String(b.dataset.id));
      if (flavor) {
        this.pushEvent("pdp_flavor_selected", { action: "add", flavor_name: flavor.name, flavor_quantity: this.mix[b.dataset.id] });
      }
      this.update();
      if (anchor) anchor.scrollIntoView({ behavior: "smooth" });
    });
  }

  bindGallery() {
    if (!this.thumbsEl) return;
    this.thumbsEl.addEventListener("click", (e) => {
      const b = e.target.closest("button");
      if (!b) return;
      this.mainImgEl.src = b.dataset.src;
      this.thumbsEl.querySelectorAll("button").forEach((x) => x.setAttribute("aria-pressed", x === b));
    });
  }

  bindFlavorZoom() {
    // O popover de detalhes do sabor era só :hover — não funciona em toque (mobile).
    // Aqui vira um toggle por clique/toque, que também funciona no desktop.
    if (!this.flavorsEl) return;
    const closeAll = () => {
      this.flavorsEl.querySelectorAll(".flavor__zoom.is-open").forEach((btn) => {
        btn.classList.remove("is-open");
        btn.setAttribute("aria-expanded", "false");
      });
    };
    this.flavorsEl.addEventListener("click", (e) => {
      const zoomBtn = e.target.closest(".flavor__zoom");
      if (zoomBtn) {
        e.preventDefault();
        e.stopPropagation();
        const wasOpen = zoomBtn.classList.contains("is-open");
        closeAll();
        if (!wasOpen) {
          zoomBtn.classList.add("is-open");
          zoomBtn.setAttribute("aria-expanded", "true");
        }
        return;
      }
      if (!e.target.closest(".flavor__popover")) closeAll();
    });
    document.addEventListener("click", (e) => {
      if (!this.flavorsEl.contains(e.target)) closeAll();
    });
  }

  bindNutritionModal() {
    if (!this.nutritionOpenEl || !this.nutritionModalEl) return;

    const renderTabs = () => {
      this.nutritionTabsEl.innerHTML = this.flavors
        .map((f, i) => `<button type="button" class="nutrition-modal__tab" data-nutrition-tab="${i}" aria-pressed="${i === 0}">${f.name}</button>`)
        .join("");
    };

    const showFlavor = (index) => {
      const flavor = this.flavors[index];
      if (!flavor) return;
      this.nutritionTabsEl.querySelectorAll("[data-nutrition-tab]").forEach((btn) => {
        btn.setAttribute("aria-pressed", String(Number(btn.dataset.nutritionTab) === index));
      });
      if (flavor.nutritionImage) {
        this.nutritionImageEl.src = flavor.nutritionImage;
        this.nutritionImageEl.hidden = false;
        this.nutritionEmptyEl.hidden = true;
      } else {
        this.nutritionImageEl.hidden = true;
        this.nutritionEmptyEl.hidden = false;
      }
      this.pushEvent("pdp_nutrition_viewed", { flavor_name: flavor.name });
    };

    renderTabs();
    this.nutritionTabsEl.addEventListener("click", (e) => {
      const tab = e.target.closest("[data-nutrition-tab]");
      if (tab) showFlavor(Number(tab.dataset.nutritionTab));
    });

    const openModal = () => {
      this.nutritionModalEl.classList.add("is-open");
      this.nutritionModalEl.setAttribute("aria-hidden", "false");
      showFlavor(0);
    };
    const closeModal = () => {
      this.nutritionModalEl.classList.remove("is-open");
      this.nutritionModalEl.setAttribute("aria-hidden", "true");
    };

    this.nutritionOpenEl.addEventListener("click", openModal);
    this.nutritionModalEl.querySelectorAll("[data-nutrition-close]").forEach((el) => {
      el.addEventListener("click", closeModal);
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeModal();
    });
  }

  bindCta() {
    this.ctaBtnEl.addEventListener("click", () => this.addToCart());
    if (this.mobileCtaEl) {
      this.mobileCtaEl.addEventListener("click", (e) => {
        if (!this.ctaBtnEl.disabled) {
          e.preventDefault();
          this.addToCart();
        }
        // se o kit ainda não está completo, o href="#comprar" leva a pessoa
        // de volta ao box de compra pra escolher os sabores
      });
    }
  }

  bindStickyBar() {
    // A barra fica visível desde o carregamento — no desktop o botão principal
    // fica no fim da coluna direita, então o atalho precisa estar sempre à mão.
    if (!this.mobilebarEl) return;
    this.mobilebarEl.classList.add("is-visible");

    // Reserva no rodapé do body a altura real da barra (varia por breakpoint),
    // pra ela nunca cobrir o fim da página. Mais confiável que depender de :has().
    const reserveSpace = () => {
      const h = this.mobilebarEl.offsetHeight || 72;
      document.body.style.paddingBottom = `${h}px`;
    };
    requestAnimationFrame(reserveSpace);
    window.addEventListener("resize", reserveSpace);
    if ("ResizeObserver" in window) {
      new ResizeObserver(reserveSpace).observe(this.mobilebarEl);
    }
  }

  update() {
    this.renderPurchaseModes();

    const total = this.sum();
    const full = total === this.qty;
    const isAssinatura = this.purchaseMode === "assinatura" && this.assinaturaUnitPriceCents > 0;
    // O desconto vem apenas do volume: aplicamos a MESMA proporção do desconto de
    // volume da compra única (tier.unitPriceCents / basePriceCents) em cima do preço
    // real do produto Assinatura (que já é diferente/menor na origem).
    const unitPriceCents = isAssinatura
      ? Math.round(this.assinaturaUnitPriceCents * (this.tier.unitPriceCents / this.basePriceCents))
      : this.tier.unitPriceCents;

    this.flavorsEl.querySelectorAll(".flavor").forEach((li) => {
      const id = li.dataset.id;
      const count = this.mix[id] || 0;
      li.querySelector("input").value = count;
      li.classList.toggle("on", count > 0);
      li.querySelector('[data-d="-1"]').disabled = count === 0;
      li.querySelector('[data-d="1"]').disabled = full;
    });

    this.mixCountEl.textContent = `${total} de ${this.qty} escolhidos`;
    this.mixCountEl.classList.toggle("done", full);

    const selectedAddons = this.addons
      .map((addon, index) => ({ addon, index }))
      .filter(({ index }) => this.addonsSelected[index]);
    const addonPriceCents = ({ addon, index }) => {
      const useSubscription = this.addonMode[index] === "assinatura" && addon.assinaturaVariantId;
      return useSubscription && addon.assinaturaPriceCents ? addon.assinaturaPriceCents : addon.priceCents;
    };
    const addonCents = selectedAddons.reduce((sum, entry) => sum + addonPriceCents(entry), 0);
    const priceCents = unitPriceCents * this.qty;
    const fromCents = this.basePriceCents * this.qty;
    const grandTotalCents = priceCents + addonCents;

    this.totalPriceEl.textContent = this.formatPrice(priceCents);
    this.totalFromEl.textContent = unitPriceCents < this.basePriceCents ? this.formatPrice(fromCents) : "";

    if (this.addonLineEl) {
      this.addonLineEl.textContent = selectedAddons
        .map((entry) => {
          const isSubscription = this.addonMode[entry.index] === "assinatura" && entry.addon.assinaturaVariantId;
          const label = isSubscription ? `${entry.addon.name} (assinatura)` : entry.addon.name;
          return `+ ${label} — ${this.formatPrice(addonPriceCents(entry))}`;
        })
        .join(" · ");
    }

    const priceReais = priceCents / 100;
    const parc = priceReais >= 300 ? 3 : priceReais >= 150 ? 2 : 1;
    this.unitLineEl.textContent = isAssinatura
      ? `${this.formatPrice(unitPriceCents)} por sachê · assinatura`
      : `${this.formatPrice(unitPriceCents)} por sachê` +
        (parc > 1 ? ` · ${parc}x sem juros de ${this.formatPrice(priceCents / parc)}` : "") +
        ` · ${this.pixDiscountPct}% off no Pix`;

    this.perkLineEl.innerHTML = !isAssinatura && this.tier.perk ? `✓ ${this.tier.perk}` : "";

    this.ctaBtnEl.disabled = !full;
    if (this.ctaLabelEl) {
      this.ctaLabelEl.textContent = full ? "Add sachês ao carrinho" : `${total}/${this.qty} sachês escolhidos`;
    }
    if (this.ctaFillEl) {
      const ctaPct = this.qty > 0 ? Math.min(100, (total / this.qty) * 100) : 0;
      this.ctaFillEl.style.width = full ? "0%" : `${ctaPct}%`;
    }

    if (this.mobileQtyEl) {
      const addonSuffix = selectedAddons.length ? ` + ${selectedAddons.map((entry) => entry.addon.name).join(" + ")}` : "";
      this.mobileQtyEl.textContent = `${this.qty} ${this.qty === 1 ? "sachê" : "sachês"}${addonSuffix}`;
    }
    if (this.mobileModeEl) {
      this.mobileModeEl.textContent = isAssinatura
        ? this.assinaturaOffPct > 0
          ? `Assinatura −${this.assinaturaOffPct}%`
          : "Assinatura"
        : "Compra única";
      this.mobileModeEl.classList.toggle("is-assinatura", isAssinatura);
    }
    if (this.mobileTotalEl) this.mobileTotalEl.textContent = this.formatPrice(grandTotalCents);
    if (this.mobileFromEl)
      this.mobileFromEl.textContent = unitPriceCents < this.basePriceCents ? this.formatPrice(fromCents) : "";
    if (this.mobileUnitEl) this.mobileUnitEl.textContent = `· ${this.formatPrice(unitPriceCents)} / sachê`;
    if (this.mobileCtaLabelEl) {
      this.mobileCtaLabelEl.textContent = full ? "Add sachês ao carrinho" : `${total}/${this.qty} sachês escolhidos`;
    }
    if (this.mobileCtaEl) {
      this.mobileCtaEl.classList.toggle("is-complete", full);
    }
    if (this.mobileCtaFillEl) {
      const pct = this.qty > 0 ? Math.min(100, (total / this.qty) * 100) : 0;
      this.mobileCtaFillEl.style.width = full ? "0%" : `${pct}%`;
    }
  }

  async addToCart() {
    if (this.ctaBtnEl.disabled) return;

    const isAssinatura = this.purchaseMode === "assinatura" && this.assinaturaUnitPriceCents > 0;

    const items = Object.entries(this.mix)
      .map(([variantId, quantity]) => {
        let id = parseInt(variantId, 10);
        if (isAssinatura) {
          const flavor = this.flavors.find((f) => String(f.variantId) === String(variantId));
          if (flavor && flavor.assinaturaVariantId) id = flavor.assinaturaVariantId;
        }
        return { id, quantity };
      })
      .filter((item) => item.quantity > 0 && item.id > 0);

    this.addons.forEach((addon, i) => {
      if (this.addonsSelected[i] && addon.variantId) {
        const useSubscription = this.addonMode[i] === "assinatura" && addon.assinaturaVariantId;
        items.push({ id: useSubscription ? addon.assinaturaVariantId : addon.variantId, quantity: 1 });
      }
    });

    if (items.length === 0) return;

    this.ctaBtnEl.disabled = true;
    if (this.ctaLabelEl) this.ctaLabelEl.textContent = "Adicionando...";

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) throw new Error("Falha ao adicionar ao carrinho");

      const cartItems = Object.entries(this.mix)
        .filter(([, quantity]) => quantity > 0)
        .map(([variantId, quantity]) => {
          const flavor = this.flavors.find((f) => String(f.variantId) === String(variantId));
          return { item_name: flavor ? flavor.name : variantId, quantity, price: this.tier.unitPriceCents / 100 };
        });
      this.addons.forEach((addon, i) => {
        if (this.addonsSelected[i] && addon.variantId) {
          cartItems.push({ item_name: addon.name, quantity: 1, price: addon.priceCents / 100 });
        }
      });
      const cartValue = cartItems.reduce((total, item) => total + item.price * item.quantity, 0);
      this.pushEvent("add_to_cart", {
        ecommerce: { currency: "BRL", value: cartValue, items: cartItems },
        purchase_mode: this.purchaseMode,
      });

      await this.refreshCartDrawer();
      if (this.ctaLabelEl) this.ctaLabelEl.textContent = "✓ Adicionado!";
    } catch (err) {
      console.error("pdp-hidrogel: erro no addToCart", err);
      if (this.ctaLabelEl) this.ctaLabelEl.textContent = "Erro ao adicionar";
    } finally {
      setTimeout(() => {
        this.update();
      }, 2000);
    }
  }

  async refreshCartDrawer() {
    const cartDrawer = document.querySelector("cart-drawer-component");
    if (!cartDrawer) return;

    const cartItemsComponent = cartDrawer.querySelector(".cart-items-component");
    const sectionId = cartItemsComponent ? cartItemsComponent.dataset.sectionId : null;
    if (!sectionId) return;

    const response = await fetch(`/?section_id=${sectionId}`);
    const newDrawerHTML = await response.text();
    const newDrawerContent = new DOMParser().parseFromString(newDrawerHTML, "text/html");

    const newCartItemsHTML = newDrawerContent.querySelector(".cart-items-component");
    if (cartItemsComponent && newCartItemsHTML) {
      cartItemsComponent.innerHTML = newCartItemsHTML.innerHTML;
    }

    const newCartBubble = newDrawerContent.querySelector(".header-actions__action .cart-bubble");
    const headerCartBubble = document.querySelector(".header-actions__action .cart-bubble");
    if (headerCartBubble && newCartBubble) {
      headerCartBubble.innerHTML = newCartBubble.innerHTML;
      headerCartBubble.setAttribute("data-cart-count", newCartBubble.dataset.cartCount);
    }

    const cartStateResponse = await fetch("/cart.js");
    const cart = await cartStateResponse.json();
    const dialogModal = cartDrawer.querySelector(".dialog-modal");
    if (dialogModal) dialogModal.classList.toggle("cart-drawer--empty", cart.item_count === 0);

    if (typeof cartDrawer.open === "function") cartDrawer.open();
  }
}

function initPdpHidrogel() {
  document.querySelectorAll("[data-pdp-hidrogel]:not(.js-initialized)").forEach((container) => {
    container.classList.add("js-initialized");
    new PdpHidrogel(container);
  });
}

document.addEventListener("DOMContentLoaded", initPdpHidrogel);
document.addEventListener("shopify:section:load", initPdpHidrogel);
